// libs
import { styled } from '@nykaa/ui-components';

// components
import Chips from '@nykaa/ui-components/Chips';
import { LegendDot } from 'shared/layouts/DetailsPage/components/ProductInfo/components/SizeOptions/styles';
import StockInfo from './StockInfo';

export const ButtonV2 = styled.div<{ selected: boolean; width: number; disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  width: max-content;
  ${({ theme }) => ` padding: 6px ${theme.spacing.spacing60}`};
  ${({ theme }) => theme.typography.bodyMedium};
  min-width: 51px;
  height: 32px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  ${({ width }) => (width === 0 ? `width: auto` : `width: ${width}px`)};
  white-space: nowrap;
  ${({ selected, theme }) =>
    selected &&
    `
  border: 1px solid ${theme.colors.textPrimary};
  background: ${theme.colors.textDecorative};
  `};
  ${({ disabled, theme }) =>
    disabled &&
    `
    opacity: 0.8;
  pointer-events: none;
  color: ${theme.colors.textDisabled};
  border-color: ${theme.colors.textDisabled};
  `};
`;

export const Button = styled(Chips)<{ selected: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  width: max-content;
  ${({ selected, theme }) => !selected && `color: ${theme.colors.textPrimary}`};
  ${({ disabled, theme }) =>
    disabled &&
    `
    opacity: 0.8;
  pointer-events: none;
  color: ${theme.colors.textDisabled};
  border-color: ${theme.colors.textDisabled};
  `};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  &&:last-child {
    margin-right: none;
  }
`;

export const Info = styled.span<{ isOutOfStock?: boolean }>`
  ${({ theme }) => theme.typography.bodyXSmall};
  color: ${({ theme, isOutOfStock }) =>
    isOutOfStock ? theme.colors.textSecondary : theme.colors.warning};
  align-self: center;
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;

export const StockIndicators = styled(LegendDot)<{ isSelected: boolean }>`
  height: 8px;
  width: 8px;
  position: absolute;
  top: 2px;
  right: 0px;
  transition: transform 0.2s ease-out;
  ${({ isSelected }) => isSelected && `transform: scale(0)`};
  ${({ theme }) => `outline: ${theme.borders.radius10} solid ${theme.colors.surface}`};
`;

export const StockInfoV2 = styled(StockInfo)`
  ${({ theme }) => theme.typography.bodySmall};
`;
